import {Navigate, Outlet} from 'react-router-dom';
import {useAuth} from '../../../api/AuthProvider';

export default function PrivateRoute() {
    const {user, bootstrapping} = useAuth();

    if (bootstrapping) {
        return <div>Loading...</div>; // optional spinner
    }

    if (!user) {
        return <Navigate to="/" replace/>;  // send back to home
    }


    return <Outlet/>;
}
